import { render, staticRenderFns } from "./FszBar.vue?vue&type=template&id=ca2b0fbc&scoped=true"
import script from "./FszBar.vue?vue&type=script&lang=js"
export * from "./FszBar.vue?vue&type=script&lang=js"
import style0 from "./FszBar.vue?vue&type=style&index=0&id=ca2b0fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2b0fbc",
  null
  
)

export default component.exports